import { I18n } from '@calendly/i18n'
import { Link } from '@calendly/ui/components/link'
import { BodyText } from '@calendly/ui/components/typography'

import { AI_EMBEDDED_DISCLAIMER_LEARN_MORE_URL } from 'features/agent_hub/ai_chat_discovery/constants'

/**
 * @param {Object} props
 * @param {boolean} props.embedded - When true, show the learn-more link (embedded rail / search).
 * @param {Record<string, string>} props.styles - CSS module: `disclaimer`; when embedded also
 */
export const AgentHubDisclaimer = ({ embedded, styles }) => {
  if (embedded) {
    return (
      <div className={styles.disclaimer}>
        <BodyText color="muted" size="small">
          {I18n.t('publisher.agent_hub.disclaimer')}
          {' '}
          <Link
            href={AI_EMBEDDED_DISCLAIMER_LEARN_MORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.embeddedDisclaimerLearnMore}
          >
            {I18n.t('publisher.agent_hub.embedded_search.learn_more')}
          </Link>
        </BodyText>
      </div>
    )
  }

  return (
    <div className={styles.disclaimer}>
      <BodyText color="muted" size="small">
        {I18n.t('publisher.agent_hub.disclaimer')}
      </BodyText>
    </div>
  )
}
